import store from "@store";
import fakeLocalStorage from "../../../helpers/fakeLocalStorage";

const API_URL_PROD = process.env.REACT_APP_API_URL_PROD;
const API_URL_DEV = process.env.REACT_APP_API_URL_DEV;

const url = process.env.NODE_ENV !== "production" ? API_URL_DEV : API_URL_PROD;

export function authRequest(config) {
  const lang = fakeLocalStorage.getItem("i18nextLng");
  const token = store.getState().user.session.sessionInfo.token;
  const role = store.getState().user.session.sessionInfo.role;
  if (lang) {
    config.headers["X-localization"] = lang;
  }
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  config.headers["X-admin"] = "true";


  if (role === "content_provider") {
    config.baseURL = url + "/api/content-provider";
  } else {
    config.baseURL = url + "/api/admin";
  }
  return config;
}

export const authResponse = [
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.data?.message === "Unauthorized") {
      if (store.getState().user.isAuthenticated) {
        store.getActions().user.removeAuthInfo();
      }
    }
    return Promise.reject(error);
  },
];
